export default __webpack_public_path__ + "static/media/order_book_dfn.4bcb0710.svg";